import React, { FunctionComponent } from "react";
import "./index.scss";

export const ContainerBox: FunctionComponent = (props) => {
  return (
    <div className={"ContainerBox"}>
      {props.children}
    </div>
  );
};
